// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2AhY-","inputDescription":"styles_inputDescription__3_4Ed"};